export const selectMain = (state) => state.mainPage;
export const selectMainIsLoading = (state) => selectMain(state).isLoading;
export const selectMainLoadingMessage = (state) => selectMain(state).loadingMessage;
export const selectMainLoadingVariant = (state) => selectMain(state).loadingVariant;
export const selectMainPortal = (state) => selectMain(state).portal;
export const selectMainRegistrationMode = (state) => selectMain(state).registrationMode;
export const selectInvitationCode = (state) => selectMain(state).invitationCode;
export const selectInviterRole = (state) => selectMain(state).inviterRole;
export const selectIsBrokerInvited = (state) => selectMain(state).isBrokerInvited;
export const selectConfiguration = (state) => selectMain(state).configuration;
export const selectIsConfigurationSet = (state) => selectMain(state).isConfigurationSet;
export const selectUserJourneyAccountType = (state) => selectMain(state).userJourneyAccountType;
export const selectMainTrustDeedAttachment = (state) =>
  selectConfiguration(state).trustDeedAttachment;

export const selectWorkflow = (state) => state.workflow;
export const selectWorkflowSteps = (state) => selectWorkflow(state).steps;
export const selectWorkflowActiveStepIndex = (state) => selectWorkflow(state).activeStepIndex;
export const selectWorkflowActiveMainStepIndex = (state) =>
  selectWorkflow(state).activeMainStepIndex;
export const selectWorkflowCompletedSteps = (state) => selectWorkflow(state).completedSteps;
export const selectWorkflowActiveStepLinks = (state) => selectWorkflow(state).activeStepLinks;
export const selectWorkflowNextStepLinks = (state) => selectWorkflow(state).nextStepLinks;
export const selectWorkflowActiveStepLinkByRel = (state, rel) =>
  selectWorkflowActiveStepLinks(state).find((x) => x.rel === rel);
export const selectWorkflowMIsIdVerificationAttemptsMaxed = (state) =>
  selectWorkflow(state).isIdVerificationAttemptsMaxed;

export const selectBusinessDetails = (state) => state.businessDetails;
export const selectBusinessValidationResult = (state) =>
  selectBusinessDetails(state).businessValidationResult;
export const selectAbn = (state) => selectBusinessValidationResult(state).abn;
export const selectMobileNumberFromInvitation = (state) =>
  selectBusinessValidationResult(state).mobileNumberFromInvitation;
export const selectCanVerifyIdUsingPrefilledDetails = (state) =>
  selectBusinessValidationResult(state).canVerifyIdUsingPrefilledDetails;
export const selectIsTrust = (state) => selectBusinessValidationResult(state).isTrust;

export const selectTrustDetails = (state) => state.trustDetails;
export const selectTrustValidationResult = (state) =>
  selectTrustDetails(state).trustValidationResult;
export const selectTrustAbn = (state) => selectTrustValidationResult(state).abn;
export const selectTrustValidationErrorMessage = (state) => selectTrustDetails(state).errorMessage;

export const selectTrusteeDetails = (state) => state.trusteeDetails;
export const selectTrusteeValidationResult = (state) =>
  selectTrusteeDetails(state).trusteeAsCompanyValidationResult;
export const selectTrusteeAbn = (state) => selectTrusteeValidationResult(state).abn;
export const selectTrusteeValidationErrorMessage = (state) =>
  selectTrusteeDetails(state).errorMessage;
export const selectTrusteeNames = (state) => selectTrusteeDetails(state).trusteeNames;

export const selectMobileNumberSkipVerify = (state) => state.mobileNumberSkipVerify;
export const selectMobileNumberSkipVerifyErrorMessage = (state) =>
  selectMobileNumberSkipVerify(state).errorMessage;

export const selectMobileVerification = (state) => state.mobileVerification;
export const selectMobileNumber = (state) =>
  selectMobileVerification(state).mobileNumber || selectMobileNumberSkipVerify(state).mobileNumber;
export const selectLoginCodeExpiry = (state) => selectMobileVerification(state).codeExpiry;
export const selectMobileValidationResult = (state) =>
  selectMobileVerification(state).validationResult;
export const selectMobileLoginCodeSendingFailed = (state) =>
  selectMobileVerification(state).loginCodeSendingFailed;
export const selectMobileVerificationMessage = (state) => selectMobileVerification(state).message;
export const selectCanResendLoginCode = (state) =>
  selectMobileVerification(state).canResendLoginCode;

export const selectIdVerification = (state) => state.idVerification;
export const selectIdVerificationResult = (state) =>
  selectIdVerification(state).idVerificationResult;
export const selectIdVerificationErrorMessage = (state) => selectIdVerification(state).errorMessage;
export const selectDirectorList = (state) => selectIdVerification(state).directorList;
export const selectHasErroredFromVerifyIdPrefilled = (state) =>
  selectIdVerification(state).hasErroredFromVerifyIdPrefilled;
export const selectIsVerifyIdPrefilledError = (state) =>
  selectIdVerification(state).isVerifyIdPrefilledError;
export const selectShadowRegisteredAccountId = (state) =>
  selectIdVerification(state).shadowRegisteredAccountId;
export const selectShadowRegisteredCaseId = (state) =>
  selectIdVerification(state).shadowRegisteredCaseId;
export const selectPEPStatus = (state) => selectIdVerification(state).pepStatus;
export const selectIsPotentialAMLIdentified = (state) =>
  selectIdVerification(state).isPotentialAMLIdentified;
export const selectSfContactId = (state) => selectIdVerification(state).sfContactId;

export const selectcaptureDirector = (state) => state.captureDirector;
export const selectcaptureDirectorSuccess = (state) => selectcaptureDirector(state).isLeadCreated;
export const selectcaptureDirectorErrorMessage = (state) => state.captureDirector.errorMessage;

export const selectBanklink = (state) => state.banklink;
export const selectSendSmsForBankConfirmation = (state) =>
  selectBanklink(state).sendSmsForBankConfirmation;
export const selectCanResendSmsForBankConfirmation = (state) =>
  selectBanklink(state).canResendSmsForBankConfirmation;

export const selectMobileNumberNoVerify = (state) => state.mobileNumber;

export const selectInvitedStatus = (state) => selectMain(state).isInvited;
